export default __webpack_public_path__ + "static/media/warning--carts--g1.2088f796.png";